import Swiper from 'swiper'

export const customSlider = () => {

	/********************************
	 * About services swiper slider
	 *******************************/
	let sliders = document.querySelectorAll('.item-aboout__slider.slider')
	sliders.forEach((slider) => {
		let sliderObject = new Swiper(slider, {
			loop: true,
			navigation: {
				nextEl: '.slider__arrow-next',
				prevEl: '.slider__arrow-prev'
			},
		})
	})

	/*************************
	 * Devices swiper slider
	 *************************/
	let deviceSliders = document.querySelectorAll('.section-devices__slider.slider')
	deviceSliders.forEach((slider) => {
		let deviceSliderObject = new Swiper(slider, {
			loop: true,
			slidesPerView: 4,
			spaceBetween: 13,
			navigation: {
				nextEl: '.slider__arrow-next',
				prevEl: '.slider__arrow-prev'
			},
			breakpoints: {
				992: {
					slidesPerView: 3,
				},
				767: {
					slidesPerView: 2,
				},
				580: {
					slidesPerView: 1,
				},
			}
		})
	})

	/*************************
	 * Certificates swiper slider
	 *************************/
	let certificatesSliders = document.querySelectorAll('.certificates-slider')
	certificatesSliders.forEach((slider) => {
		let certificatesSliderObject = new Swiper(slider, {
			loop: true,
			slidesPerView: 4,
			spaceBetween: 13,
			navigation: {
				nextEl: '.slider__arrow-next',
				prevEl: '.slider__arrow-prev'
			},
			breakpoints: {
				992: {
					slidesPerView: 3,
				},
				767: {
					slidesPerView: 2,
				},
				580: {
					slidesPerView: 1,
				},
			}
		})
	})
}